var LoginURL = "http://www.izhihui.net/bak";
export default {
  LoginURL,
};
